import { ReparoApi } from './index';

export type GrantConsultantAccessParams = {
    userId: string;
    resourceKeys: string[];
};

export type ConsultantAccessResponse = {
    accessId: string;
    userId: string;
    resourceKey: string;
    merchantId: string;
    grantedBy?: string | null;
};

export type ConsultantAccessDetail = {
    resourceKey: string;
    hiddenColumns: string[] | null;
};

export const getMyConsultantAccess = (): Promise<ConsultantAccessDetail[]> =>
    ReparoApi({
        method: 'GET',
        url: '/consultant-access/me',
        body: undefined,
    }) as unknown as Promise<ConsultantAccessDetail[]>;

export const grantConsultantAccess = (
    dto: GrantConsultantAccessParams,
): Promise<ConsultantAccessResponse[]> =>
    ReparoApi({
        method: 'POST',
        url: '/consultant-access/grant',
        body: JSON.stringify(dto),
    }) as unknown as Promise<ConsultantAccessResponse[]>;

export const revokeConsultantAccess = (accessId: string): Promise<void> =>
    ReparoApi({
        method: 'DELETE',
        url: `/consultant-access/${accessId}`,
        body: undefined,
    }) as unknown as Promise<void>;
